import { INTERNAL_DATA_LAKE_QUERY_TYPE } from 'data-lake/preview/Constants';

export const INTERNAL_DATA_LAKE_STORAGE_TYPE = 'ICEBERG';
export const INTERNAL_DATA_LAKE_ID = '__internal_data_lake__';

export const INTERNAL_DATA_LAKE_QUERY = {
  'type': INTERNAL_DATA_LAKE_QUERY_TYPE,
  'query_string': '',
} as const;
